import { render, staticRenderFns } from "./ChooseAccountingProductAndAreas.vue?vue&type=template&id=45eb3924"
import script from "./ChooseAccountingProductAndAreas.vue?vue&type=script&lang=js"
export * from "./ChooseAccountingProductAndAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports